module.exports = __webpack_public_path__ + "static/media/dp.07e3d3b3.jpeg";